import InvoiceDataTable from "@/components/Invoice/InvoiceDataTable.vue";
import InvoiceMonthSelector from "@/components/Invoice/InvoiceMonthSelector.vue";
import dateFormatter from "@/utility/dateFormatter";
import moment from "moment";
import Vue from "vue";
import AdditionalSalaryModal from "@/components/Salary/AdditionalSalaryModal/AdditionalSalaryModal.vue";
import VariableSalaryModal from "@/components/Salary/VariableSalaryModal/VariableSalaryModal.vue";
import { mapGetters } from "vuex";
import InvoiceDetailsModal from "@/components/Invoice/InvoiceDetailsModal.vue";
import CreateInvoiceModal from "@/components/Invoice/CreateInvoiceModal.vue";
export default Vue.extend({
    components: {
        InvoiceDataTable,
        InvoiceMonthSelector,
        VariableSalaryModal,
        AdditionalSalaryModal,
        InvoiceDetailsModal,
        CreateInvoiceModal,
    },
    data() {
        return {
            variableSalaryDialog: false,
            additionalSalaryDialog: false,
            loading: false,
            selectedDate: dateFormatter.newDateString(),
            items: [],
            invoices: [],
            selectedInvoice: {},
            invoiceModalOpen: false,
            invoiceDetails: null,
            createInvoiceModalOpen: false,
        };
    },
    async mounted() {
        this.loadInvoices();
    },
    computed: {
        ...mapGetters({
            currentUser: "getLoggedInUser",
            employees: "getGlobalEmployeesAdmin",
        }),
        selectedMonth() {
            return dateFormatter.fromDateString(this.$data.selectedDate).getMonth();
        },
        selectedYear() {
            return dateFormatter.fromDateString(this.$data.selectedDate).getYear();
        },
    },
    filters: {
        toReadableMonth(date) {
            return dateFormatter.fromDateString(date).format.toMonthYearText;
        },
    },
    methods: {
        async openInvoiceModal(item) {
            if (!item) {
                return console.error("No argument passed to openInvoiceModal");
            }
            const invoiceDetailsResponse = await this.$store.dispatch("fetchInvoiceDetails", item.invoiceId);
            if (invoiceDetailsResponse.status !== 200) {
                return console.error("Could not fetch invoice details");
            }
            const employeesSortedById = await this.employeesById();
            const invoiceDetails = invoiceDetailsResponse.data.map((invoiceDetail) => {
                return {
                    ...invoiceDetail,
                    salesResponsible: employeesSortedById[invoiceDetail.userId],
                };
            });
            this.selectedInvoice = item;
            this.invoiceDetails = invoiceDetails;
            this.invoiceModalOpen = true;
        },
        async createInvoice(salesOrder) {
            if (!salesOrder)
                return console.error("Sales Order not defined in 'createInvoice()'");
            const invoiceSendDate = salesOrder.invoiceDate;
            const invoiceDate = this.$data.selectedDate;
            const response = await this.$store.dispatch("createInvoice", {
                year: moment(invoiceDate).format("YYYY"),
                month: moment(invoiceDate).format("MM"),
                salesOrderId: salesOrder.id,
                invoiceDate: moment.utc(invoiceSendDate).format(),
            });
            if (response && response.status === 204) {
                this.loadInvoices();
            }
            return;
        },
        async loadInvoices() {
            this.loading = true;
            const employeesSortedById = await this.employeesById();
            const salesOrdersResponse = await this.$store.dispatch("getSalesOrdersAsync");
            if (salesOrdersResponse.status !== 200) {
                return;
            }
            const invoiceResponse = await this.$store.dispatch("fetchInvoices", {
                selectedYear: this.selectedYear,
                selectedMonth: this.selectedMonth,
            });
            if (invoiceResponse.status !== 200) {
                return console.error("Could not fetch invoices");
            }
            const salesOrdersFilteredByDate = salesOrdersResponse.data.filter((salesOrder) => {
                if (!salesOrder.to)
                    return moment(this.selectedDate).isSameOrAfter(moment(salesOrder.from).startOf("month"));
                return moment(this.selectedDate).isBetween(moment(salesOrder.from).startOf("month"), moment(salesOrder.to).endOf("month"), undefined, "[]");
            });
            /*
            console.log("=====SALESORDERS=======");
            console.log(salesOrdersFilteredByDate);
            console.log("=====INVOICES======");
            console.log(invoiceResponse.data);
       */
            let sortedInvoicesById = [];
            if (invoiceResponse.data.length > 0) {
                sortedInvoicesById = invoiceResponse.data.reduce((acc, invoice) => {
                    return { ...acc, [invoice.salesOrderId]: invoice };
                }, { [invoiceResponse.data[0].salesOrderId]: invoiceResponse.data[0] });
            }
            /*      console.log("======sortedInvoicesById======");
            console.log(sortedInvoicesById); */
            const joinedSalesOrdersAndInvoices = salesOrdersFilteredByDate.map((salesOrder) => {
                let invoiceId = null;
                let totalAmount = null;
                let totalAmountInclVAT = null;
                const employeeName = employeesSortedById[salesOrder.userId] || null;
                let invoiceDate = null;
                if (sortedInvoicesById[salesOrder.id]) {
                    invoiceId = sortedInvoicesById[salesOrder.id].id;
                    totalAmount = sortedInvoicesById[salesOrder.id].totalAmount;
                    totalAmountInclVAT =
                        sortedInvoicesById[salesOrder.id].totalAmountInclVAT;
                    invoiceDate = sortedInvoicesById[salesOrder.id].to;
                }
                return {
                    ...salesOrder,
                    invoiceId,
                    totalAmount,
                    totalAmountInclVAT,
                    employeeName,
                    invoiceDate,
                };
            });
            /*       console.log("JoinedSalesOrdersAndInvoices");
            console.log(joinedSalesOrdersAndInvoices);
       */
            this.items = joinedSalesOrdersAndInvoices;
            //Checka nedan
            this.invoices = invoiceResponse.data;
            this.loading = false;
        },
        async employeesById() {
            if (!this.employees.employees ||
                (this.employees.employees && this.employees.employees.length === 0)) {
                //Fetch employees
                const employeesResponse = await this.$store.dispatch("adminLoadEmployees");
                if (employeesResponse.status !== 200) {
                    return {};
                }
                const employeesSortedById = employeesResponse.data.reduce((acc, employee) => {
                    return {
                        ...acc,
                        [employee.userId]: `${employee.firstName} ${employee.lastName}`,
                    };
                }, {
                    [employeesResponse.data[0]
                        .userId]: `${employeesResponse.data[0].firstName} ${employeesResponse.data[0].lastName}`,
                });
                return employeesSortedById;
            }
            else {
                const employeesSortedById = this.employees.employees.reduce((acc, employee) => {
                    return {
                        ...acc,
                        [employee.userId]: `${employee.firstName} ${employee.lastName}`,
                    };
                }, {
                    [this.employees.employees[0]
                        .userId]: `${this.employees.employees[0].firstName} ${this.employees.employees[0].lastName}`,
                });
                return employeesSortedById;
            }
        },
        onPreviousMonth() {
            this.selectedDate = dateFormatter
                .fromDateString(this.selectedDate)
                .subtract.months(1);
            this.loadInvoices();
        },
        onToday() {
            this.selectedDate = dateFormatter.newDateString();
            this.loadInvoices();
        },
        onNextMonth() {
            this.selectedDate = dateFormatter
                .fromDateString(this.selectedDate)
                .add.months(1);
            this.loadInvoices();
        },
    },
});
